import { createFormContext } from "@mantine/form"
import { type InstructorRequest } from "../../../shared/types/instructor"

export const [
  FormProvider,
  useFormContext,
  useForm,
] = createFormContext<InstructorRequest>()
